import React from 'react';
import { ProviderField } from './providerTemplates';

interface Props {
  field: ProviderField;
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

const ProviderFieldInput: React.FC<Props> = ({ field, value, onChange, error }) => {
  const renderInput = () => {
    const baseClasses = "mt-1 block w-full rounded-md shadow-sm sm:text-sm border-gray-300 focus:border-indigo-500 focus:ring-indigo-500";
    const errorClasses = error 
      ? "border-red-300 focus:border-red-500 focus:ring-red-500" 
      : "border-gray-300 focus:border-indigo-500 focus:ring-indigo-500";

    switch (field.type) {
      case 'text':
      case 'email':
        return (
          <input
            type={field.type}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            required={field.required}
            className={`${baseClasses} ${errorClasses}`}
            placeholder={field.help}
          />
        );
      
      case 'password':
        return (
          <input
            type="password"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            required={field.required}
            className={`${baseClasses} ${errorClasses}`}
            placeholder="Enter your password or token"
            autoComplete="new-password"
          />
        );
      
      case 'textarea':
        return (
          <textarea
            value={value}
            onChange={(e) => onChange(e.target.value)}
            required={field.required}
            rows={6}
            className={`${baseClasses} ${errorClasses}`}
            placeholder={field.help}
          />
        );
      
      case 'select':
        return (
          <select
            value={value}
            onChange={(e) => onChange(e.target.value)}
            required={field.required}
            className={`${baseClasses} ${errorClasses}`}
          >
            <option value="">Select {field.label.toLowerCase()}</option>
            {field.options?.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        );
      
      default:
        return null;
    }
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700">
        {field.label}
        {field.required && <span className="text-red-500 ml-1">*</span>}
      </label>
      {renderInput()}
      {field.help && (
        <p className="mt-1 text-sm text-gray-500">
          {field.help}
        </p>
      )}
      {error && (
        <p className="mt-1 text-sm text-red-600">
          {error}
        </p>
      )}
    </div>
  );
};

export default ProviderFieldInput;